import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Button} from '../../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {ButtonGroup} from '../../../../../../libs/shared/ui/src/components/buttons/buttonGroup/buttonGroup';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {LocalApplicationModel} from '../../../../../models/api/localApplicationModel';

/*
 * Props.
 */

interface SettingsDevelopersApplicationInfoIconProps {
  application: LocalApplicationModel;
}

/*
 * Style.
 */

const StyledIconWrapperDiv = styled.div`
  display: flex;
  flex-flow: row;
  gap: 20px;
`;

const StyledIconPlaceholderDiv = styled.div`
  display: flex;
  height: 100px;
  width: 100px;
  background: ${(p) => p.theme.greys.shade30};
  border-radius: 9000px;
  align-items: center;
  justify-content: center;
`;

const StyledIcon = styled(Icon)`
  color: ${(p) => p.theme.greys.shade70};
`;

const StyledDetailsWrapperDiv = styled.div`
  display: flex;
  flex-flow: column;
  flex: 1;
  padding: 10px 0;
  gap: 10px;
`;

const StyledDetailsMessageDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  line-height: 22px;
`;

/*
 * Component.
 */

// TODO: Add a dialog to upload the image, wire up the edit buttons. As this component doesn't do anything
//       right now.
export const SettingsDevelopersApplicationInfoIcon: FC<SettingsDevelopersApplicationInfoIconProps> = (
  props,
) => (
  <StyledIconWrapperDiv>
    {renderIconOrPlaceholder()}
    <StyledDetailsWrapperDiv>
      <StyledDetailsMessageDiv>
        <Trans id="developers-application-info-icon-description">
          Your app icon is shown to users to identify your application. Recommended format: 160x160 px PNG
          with a transparent background
        </Trans>
      </StyledDetailsMessageDiv>
      <ButtonGroup>
        <Button size={VisualSizesEnum.SMALL} variant={ButtonVariantsEnum.PRIMARY}>
          <Trans id="developers-application-info-icon-edit-button">Edit</Trans>
        </Button>
        <Button size={VisualSizesEnum.SMALL} variant={ButtonVariantsEnum.SECONDARY_DANGER} isDisabled>
          <Trans id="developers-application-info-remove-button">Remove</Trans>
        </Button>
      </ButtonGroup>
    </StyledDetailsWrapperDiv>
  </StyledIconWrapperDiv>
);

/*
 * Helpers.
 */

function renderIconOrPlaceholder() {
  return (
    <StyledIconPlaceholderDiv>
      <StyledIcon name="integrationsFilledSmall" size={50} />
    </StyledIconPlaceholderDiv>
  );
}
